import { useSelector } from 'react-redux';
import {
  twitterAvatarSrcSelector,
  twitterUsernameSelector,
} from 'redux/modules/social';
import { MAX_CHARS_CAPTIONS_PREVIEW } from './constants';

function formatDescription(val: string) {
  if (typeof val !== 'string') return undefined;

  return val.substring(0, MAX_CHARS_CAPTIONS_PREVIEW);
}

interface UseTwitterPostModalConfig {
  defaultDescription?: string;
}

export default function useTwitterPostModalSelector(
  config: UseTwitterPostModalConfig = {},
) {
  const username = useSelector(twitterUsernameSelector);
  const avatarSrc = useSelector(twitterAvatarSrcSelector);

  const { defaultDescription } = config;

  return {
    username,
    avatarSrc,
    defaultDescription: formatDescription(defaultDescription),
  };
}
